import React from "react";
import { Box, Typography, Divider } from "@mui/material";

export default function MessageViewer({ selected, filter, insideCase }) {
  return (
    <Box sx={{ width: "100%" }}>
      <Box display="flex" justifyContent="flex-end" mb={1}>
        <Typography variant="caption">{selected?.date}</Typography>
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Typography variant="h5" fontWeight={700} mb={1}>
        {selected?.subject}
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <Box mb={3}>
        {insideCase || filter === "sent" ? (
          <Typography>
            <strong>Para:</strong>{" "}
            {selected?.to_relation?.name + " " + selected?.to_relation?.surname}
          </Typography>
        ) : (
          <Typography>
            <strong>De:</strong>{" "}
            {selected?.from_relation?.name +
              " " +
              selected?.from_relation?.surname}
          </Typography>
        )}
      </Box>

      <Divider sx={{ mb: 3 }} />

      <Box
        sx={{ lineHeight: 1.7 }}
        dangerouslySetInnerHTML={{ __html: selected?.message }}
      />
    </Box>
  );
}
